import React from 'react';
import { Modal } from 'antd';

type Props = {
  open: boolean;
  onClose: () => void;
  onOpenProfile: () => void;
};

const ProfileSetupModal: React.FC<Props> = ({ open, onClose, onOpenProfile }) => {
  return (
    <Modal
      title="完善个人资料"
      open={open}
      onCancel={onClose}
      onOk={() => {
        onClose();
        onOpenProfile();
      }}
      okText="去设置"
      cancelText="稍后"
      centered
    >
      <p>请先设置头像，并填写姓名或昵称，以便团队成员识别你。</p>
    </Modal>
  );
};

export default ProfileSetupModal;
